// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3DWOr","productName":"Table_productName__1z0WL"};